export const tagging = {
  taggingId: {
    type: String,
    required: true,
  },
};

const ALLOWED_RESOLUTIONS = ['sm', 'md'];
const validateResolution = (value) => {
  if (!value?.md) return false;

  return Object.entries(value).every(
    ([resolution, src]) =>
      ALLOWED_RESOLUTIONS.includes(resolution) && src && typeof src === 'string',
  );
};

export const common = {
  image: {
    type: Object,
    required: true,
    validator: validateResolution,
  },
  imageAlt: {
    type: String,
    default: 'Product with interactive hotspots',
  },
  markerButtonAccessibleLabel: {
    type: String,
    default: 'Additional information concerning this product',
  },
  modalCloseButtonAccessibleLabel: {
    type: String,
    default: 'Close dialog',
  },
  pois: {
    type: Array,
    default: () => [],
  },
};
